interface ConfirmOptions {
  title: string
  message: string
  action: string // confirm button label: "Delete", "Remove", "Discard"
  /** The action destroys or discards something. Defaults to true; pass false for a plain confirm. */
  danger?: boolean
}

let resolveCallback: ((value: boolean) => void) | null = null

export function useConfirmDialog() {
  const isOpen = useState('confirmDialog:isOpen', () => false)
  const options = useState<ConfirmOptions>('confirmDialog:options', () => ({
    title: '',
    message: '',
    action: 'Confirm'
  }))

  function confirm(opts: ConfirmOptions): Promise<boolean> {
    options.value = opts
    isOpen.value = true
    return new Promise<boolean>((resolve) => {
      resolveCallback = resolve
    })
  }

  function _resolve(value: boolean) {
    isOpen.value = false
    resolveCallback?.(value)
    resolveCallback = null
  }

  return { confirm, isOpen, options, _resolve }
}
